import { ajax } from 'cadenza/api-client/api';
import { PARAMETER_MIMETYPE } from 'cadenza/api-client/api-constants';
import type { WorkOrderId } from 'cadenza/api-client/workorder-api';

interface ExportPermissionDto {
  warning: string;
  error: string;
}

export function canExport (searchUrl: string, mimeType: string) {
  if (!searchUrl) {
    searchUrl = '?';
  }

  return ajax<ExportPermissionDto>(`/processingChain/excelExportPermission${searchUrl}&${PARAMETER_MIMETYPE}=${mimeType}`, {
    traditional: true,
    method: 'GET'
  });
}

/**
 * Starts Work Order that is in charge of table export.
 *
 * @param searchUrl
 * @param mediaType
 * @return Returns id of the work order.
 */
export function startExport (searchUrl: string, mediaType: string): Promise<WorkOrderId> {
  const searchParams = new URLSearchParams(searchUrl);
  searchParams.append(PARAMETER_MIMETYPE, mediaType);
  return ajax('/processingChain' + '?' + searchParams);
}
